import { t } from 'i18next'

import { ButtonsCancelSave } from '~/components/Buttons'
import { FormGroup, Label } from '~/components/unform'
import { Container as ContainerInput } from '~/components/unform/Input/styles'

import DestinationUrlRow from '../DestinationUrlRow'

export type DestinationUrlEditorEntry = {
  url: string
  brand?: string
  name?: string
  inputLabel?: string
  publisher_id?: string
}

const DestinationUrlsEditor = ({
  entries,
  onChange,
  onCancel,
  onSubmit,
  isSaving = false,
  showHelperText = false,
  ariaLabel
}: {
  entries: DestinationUrlEditorEntry[]
  onChange: (index: number, url: string) => void
  onCancel: () => void
  onSubmit: () => void
  isSaving?: boolean
  showHelperText?: boolean
  ariaLabel?: string
}) => (
  <form
    aria-label={ariaLabel}
    onSubmit={event => {
      event.preventDefault()
      onSubmit()
    }}
  >
    {showHelperText && (
      <FormGroup>
        <Label helperText={t('rm:adsDestination.helperText')} />
      </FormGroup>
    )}

    <div className="d-flex flex-column gap-3">
      {entries.map((entry, index) => (
        <DestinationUrlRow
          key={`${entry.publisher_id ?? ''}-${entry.brand ?? index}`}
          url={entry.url}
          name={entry.name}
          inputLabel={entry.inputLabel || entry.name}
        >
          <ContainerInput>
            <input
              value={entry.url}
              aria-label={entry.inputLabel || entry.name}
              onChange={event => onChange(index, event.target.value)}
            />
          </ContainerInput>
        </DestinationUrlRow>
      ))}
    </div>

    <ButtonsCancelSave
      onCancelClick={onCancel}
      isLoading={isSaving}
      showSavingChangesLoading
    />
  </form>
)

export default DestinationUrlsEditor
